import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {IS_BROWSER} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/injectiontokens";
import {DOCUMENT} from "@angular/common";
import {WebFlowContainerComponent} from "../webflowcontainer.component";
import {CurrenciesPopupComponent} from "../../parts/currenciespopup/currenciespopup.component";
import {CryptosPopupComponent} from "../../parts/cryptopopup/cryptospopup.component";
import {ActivatedRoute, Router, RouterLinkActive} from "@angular/router";
import {ExchangeService} from "@aparraga/ahoracrypto-client-common/src/app/common/exchange/exchange.service";
import {
  PurchaseFlowHelperService
} from "@aparraga/ahoracrypto-client-common/src/app/common/flowhelpers/purchaseflowhelper.service";
import {
  RegistrationFlowHelperService
} from "@aparraga/ahoracrypto-client-common/src/app/common/flowhelpers/registrationflowhelper.service";
import {StringUtils} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/stringutils";
import {ReplaySubject, Subscription} from "rxjs";
import {NavigationService} from "@aparraga/ahoracrypto-client-common/src/app/common/navigation/navigation.service";
import {JsLoaderService} from "../../jsloader/jsloader.service";


@Component({
    selector: 'cryptoform1',
    templateUrl: './cryptoform1.component.html',
    styleUrls: [
        './css/custom.scss',
        './css/normalize.scss',
        './css/webflow.scss',
        './css/ahoracryptoes-54c43cd2d8f-daf1d3078fd47.webflow.scss',
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CryptoForm1Component extends WebFlowContainerComponent implements AfterViewInit {

  protected override webflowPage = '65f2040920efdcba4918e3a9';
  protected override webflowSite = '65f2040920efdcba4918e3a2';
  protected override resources = [
    '/assets/landings/landing1/js/webflow.js',
  ]

  protected subscriptions: Subscription[] = new Array<Subscription>();
  public currentCryptoExchangeRate: number;
  public referral: string;
  public offerText: string;
  public offerTooltipText: string;
  public initialCryptoExchangeRateFormatted: string;
  public showOffer = false;
  public countUpOptions = {
    decimalPlaces: 12
  }

  public eventsOnTabs$ = new ReplaySubject();

  public title = 1;

  public _action = 'buy';
  get action(): string {
    return this._action;
  }
  @Input() set action(value: string) {
    this._action = value;
    this.resetArrow();
    this.eventsOnTabs$.next(value);
  }

  @ViewChild('currenciespopup') currenciespopup: CurrenciesPopupComponent;
  @ViewChild('cryptospopup') cryptospopup: CryptosPopupComponent;
  @ViewChild('buyTab') buyTab: ElementRef<HTMLElement>;
  @ViewChild('sellTab') sellTab: ElementRef<HTMLElement>;

  @ViewChild('botwarning') public botwarning: ElementRef<HTMLElement>;

  public constructor(
    @Inject(IS_BROWSER) protected override isBrowser: boolean,
    @Inject(DOCUMENT) protected override document: Document,
    protected router: Router,
    protected exchangeService: ExchangeService,
    private renderer: Renderer2,  //DONT REMOVE THIS LINE
    protected override jsLoaderService: JsLoaderService, //DONT REMOVE THIS LINE
    protected navigationService: NavigationService,
    protected route: ActivatedRoute,
    public purchaseFlowHelperService: PurchaseFlowHelperService,
    public registrationFlowHelperService: RegistrationFlowHelperService,
    protected stringUtils: StringUtils)
  {
    super();

    this.subscriptions.push(this.route.fragment.subscribe((fragment: any) => {
      if(fragment == 'buy') {
        this.action = 'buy';
      }
      else if(fragment == 'sell') {
        this.action = 'sell';
      }
    }));

    this.purchaseFlowHelperService.buildForm();

    this.purchaseFlowHelperService.fieldToValidate = ['currencyAmount', 'cryptoAmount'];

    let exchangePrice = this.exchangeService.getExchangePrice(this.purchaseFlowHelperService.selectedCrypto, this.purchaseFlowHelperService.selectedCurrency);
    if(exchangePrice != null) {
      this.currentCryptoExchangeRate = exchangePrice.price;
      this.countUpOptions['startVal'] = this.currentCryptoExchangeRate;
      this.initialCryptoExchangeRateFormatted = this.stringUtils.formatCurrency(this.currentCryptoExchangeRate);
    }
    this.countUpOptions['formattingFn'] = this.stringUtils.formatCurrency.bind(this.stringUtils);

    this.subscriptions.push(this.exchangeService.exchangePricesSubject$.subscribe(exchangeRates => {
      this.updateCryptoInformation();
    }));

    this.purchaseFlowHelperService.onCurrencySelected$.subscribe(() => {
      this.updateCryptoInformation();
    });
    this.purchaseFlowHelperService.onCryptoSelected$.subscribe(() => {
      this.updateCryptoInformation();
    });

  }


  ngAfterViewInit() {

    //scroll to top:
    if(this.isBrowser) {

      // Added a try-catch block to handle potential jQuery errors
      try {
        this.configureWebflow().then(() => {

          //move down and up the scroll to force the webflow animations to work
          setTimeout(() => {
            window.scrollTo(0, 1);
            setTimeout(() => {
              window.scrollTo(0, 0);
            }, 100);
          }, 500);

          setTimeout(() => {
            this.subscriptions.push(this.eventsOnTabs$.subscribe(event => {
              if (event == 'buy') {
                console.log('buy');
                // Use a safer method to access DOM elements
                if (this.buyTab && this.buyTab.nativeElement) {
                  this.buyTab.nativeElement.click();
                }
              } else if (event == 'sell') {
                console.log('sell');
                // Use a safer method to access DOM elements
                if (this.sellTab && this.sellTab.nativeElement) {
                  this.sellTab.nativeElement.click();
                }
              }
            }));
          }, 100);
        }).catch(error => {
          console.error('Error configuring webflow:', error);
        });
      } catch (error) {
        console.error('Error in ngAfterViewInit:', error);
      }

    }


    this.referral = this.navigationService.getReferral();
    if(this.referral != null) {
      this.updateOfferTooltipText();
      this.showOffer = true;
    }

    // Safer way to access child components
    if (this.currenciespopup) {
      this.purchaseFlowHelperService.currenciespopup = this.currenciespopup;
    }
    if (this.cryptospopup) {
      this.purchaseFlowHelperService.cryptospopup = this.cryptospopup;
    }

  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  public onSubmit() {
    if(this.action == 'buy') {
      if (this.purchaseFlowHelperService.isValidForm()) {
        this.purchaseFlowHelperService.updateCart().then(() => {
          this.router.navigate(['/purchaseflow']);
        });
      }
    }
    else {
      this.router.navigate(['/salesflow']);
    }
  }

  public onCurrencySelected(event) {
    this.purchaseFlowHelperService.selectCurrency(event);
    this.updateOfferTooltipText();
  }

  public updateOfferTooltipText() {
    this.offerText = this.stringUtils.formatCurrency(5, false) + ' gratis';
    this.offerTooltipText = this.stringUtils.formatCurrency(5, false) + ' gratis por compras superiores a ' + this.stringUtils.formatCurrency(100, false) + '<br />Por usar el link de referido de ' + this.referral;
  }

  protected updateCryptoInformation() {
    this.currentCryptoExchangeRate = this.exchangeService.calculateExchange(this.purchaseFlowHelperService.selectedCrypto, 1, this.purchaseFlowHelperService.selectedCurrency);
  }

  public mouseEnterOnArrow() {
    //get elements with cursor-pointer class
    let elements = document.getElementsByClassName('cursor-pointer');
    for(let i = 0; i < elements.length; i++) {
      this.renderer.removeClass(elements[i], 'out');
      this.renderer.addClass(elements[i], 'over');
    }
  }

  public mouseLeaveOutOfArrow() {
    this.resetArrow();
  }

  protected resetArrow() {
    //get elements with cursor-pointer class
    let elements = document.getElementsByClassName('cursor-pointer');
    for(let i = 0; i < elements.length; i++) {
      this.renderer.removeClass(elements[i], 'over');
      this.renderer.addClass(elements[i], 'out');
    }
  }

}
